"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = __importStar(require("three"));
const gsap_1 = require("gsap");
const Util_1 = __importDefault(require("../../Util"));
class DownCircle extends THREE.Object3D {
    constructor(width = 1, height = 1) {
        super();
        this.width = width;
        this.height = height;
        this.shape = null;
        this.wireframe = null;
        this.rocks = [];
        this.isHide = false;
        this._createShape();
    }
    draw() {
    }
    hide(cb) {
        this.isHide = true;
        this.rocks.forEach((rock) => {
            const duration = Util_1.default.map(rock.position.y, -4, 23, 0.3, 2.5);
            gsap_1.gsap.to(rock.position, {
                duration: duration,
                x: rock.position.x * 2,
                y: Util_1.default.random(-4, -12),
                ease: 'sine.out',
            });
        });
        gsap_1.gsap.delayedCall(2.6, () => {
            cb();
        });
    }
    update() {
        this.rocks.forEach((rock) => {
            rock.update();
            if (!this.isHide) {
                rock.position.y += rock.speed;
                if (rock.position.y < -4) {
                    rock.position.y = 23;
                }
            }
        });
        this.rotation.y += 0.005;
    }
    _createShape() {
        for (let i = 0; i < 20; i++) {
            const dist = Math.random() * 4 + 1;
            const x = Math.cos(i / 3) * dist;
            const y = 22 + Math.random() * 20;
            const z = Math.sin(i / 3) * dist;
            const size = Math.random() * 1 + 0.1;
            const rock = new Rock();
            rock.scale.set(size, size, size);
            rock.position.set(x, y, z);
            rock.speed = -Util_1.default.random(0.02, 0.15);
            this.add(rock);
            this.rocks.push(rock);
        }
    }
}
exports.default = DownCircle;
class Rock extends THREE.Object3D {
    constructor() {
        super();
        this.uniforms = {
            u_progress: { value: 0.0 },
            u_time: { value: 0.0 },
            u_amp: { value: Util_1.default.random(0.1, 0.7) },
            fogColor: { type: 'c', value: new THREE.Color() },
            fogNear: { type: 'f', value: 0.0 },
            fogFar: { type: 'f', value: 0.0 },
        };
        this.shape = null;
        this.wireframe = null;
        this.speed = 0;
        this.timeGap = Util_1.default.random(0.01, 0.03);
        this.rotX = Util_1.default.random(0.003, 0.01);
        this.rotY = Util_1.default.random(0.003, 0.01);
        this._create();
    }
    update() {
        this.uniforms.u_time.value += this.timeGap;
        this.rotation.y += this.rotX;
        this.rotation.x += this.rotY;
    }
    _create() {
        const geo = new THREE.SphereGeometry(1, 32, 32);
        const mat = new THREE.ShaderMaterial({
            vertexShader: vs,
            fragmentShader: fs,
            uniforms: this.uniforms,
            side: THREE.DoubleSide,
            fog: true,
            wireframe: false,
        });
        this.shape = new THREE.Mesh(geo, mat);
        this.add(this.shape);
    }
    _createWireframe() {
        this.wireframe = new THREE.Mesh(new THREE.PlaneBufferGeometry(this.width, this.height, 1, 1), new THREE.MeshBasicMaterial({ color: 0xff0000, wireframe: true }));
        this.add(this.wireframe);
    }
}
const vs = `
  uniform float u_time;
  uniform float u_amp;

  // http://byteblacksmith.com/improvements-to-the-canonical-one-liner-glsl-rand-for-opengl-es-2-0/
  float random(vec2 co)
  {
    float seed = 12.9898;
            
    highp float a = seed;
    highp float b = 78.233;
    highp float c = 43758.5453;
    highp float dt= dot(co.xy ,vec2(a,b));
    highp float sn= mod(dt,3.14);
    return fract(sin(sn) * c);
  }

  // 2D Noise based on Morgan McGuire @morgan3d
  // https://www.shadertoy.com/view/4dS3Wd
  float noise (in vec2 st) {
    vec2 i = floor(st);
    vec2 f = fract(st);

    // Four corners in 2D of a tile
    float a = random(i);
    float b = random(i + vec2(1.0, 0.0));
    float c = random(i + vec2(0.0, 1.0));
    float d = random(i + vec2(1.0, 1.0));

    // Smooth Interpolation

    // Cubic Hermine Curve.  Same as SmoothStep()
    vec2 u = f*f*(3.0-2.0*f);
    // u = smoothstep(0.,1.,f);

    // Mix 4 coorners porcentages
    return mix(a, b, u.x) +
      (c - a)* u.y * (1.0 - u.x) +
      (d - b) * u.x * u.y;
  }

  void main() {
    vec3 pos = position;

    float n = noise(vec2(pos.x, pos.y));
    float amplitude = sin(u_time * n) * 0.1 + 0.04;
    amplitude = n * u_amp;
    
    pos.z   += cos(4. * pos.y + u_time * 10.) * amplitude;
    //pos.z   += cos(14. * uv.x  + 8. * u_time) * amplitude;

    //float amplitude = sin(u_time * pos.x) * 0.2 + 0.1;
	  //float x = u_time + (u_time + uv.x * u_time);
    //pos.x   += cos(14. * uv.y  + 8. * u_time) * amplitude;
    //pos.y   += sin(4. * uv.x  + 8. * u_time) * amplitude * 0.2;

    gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
  }
`;
const fs = `
  precision mediump float;
  uniform float u_progress;
  uniform vec3 fogColor;
  uniform float fogNear;
  uniform float fogFar;

  void main() {
    gl_FragColor = vec4(1.0, 1.0, 1.0, 1.0);
    #ifdef USE_FOG
      #ifdef USE_LOGDEPTHBUF_EXT
        float depth = gl_FragDepthEXT / gl_FragCoord.w;
      #else
        float depth = gl_FragCoord.z / gl_FragCoord.w;
      #endif
      float fogFactor = smoothstep( fogNear, fogFar, depth );
      gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
      //gl_FragColor = vec4(gl_FragCoord.z);
    #endif
  }
`;
